/* eslint-disable quotes */
/* eslint-disable semi */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
import users from './modules/users';
import licensees from './modules/licensees';
import addLicenseManager from './modules/addLicenseManager';
import snackbar from './modules/snackbar';
import tiers from './modules/tiers';
import businessFunction  from './modules/businessFunction';
import designations from './modules/designations';
import domains from './modules/domains';
import departments from './modules/departments';
import valueStreamMetrics from './modules/valueStreamMetrics';
import analytics from './modules/analytics'; 
import Marketing from './modules/marketing'
Vue.use(Vuex);

var sls = new SecureLS({ isCompression: false });
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => sls.get(key),
        setItem: (key, value) => sls.set(key, value),
        removeItem: (key) => sls.remove(key),
      },
    }),
  ],
  modules: {
    users,
    licensees,
    addLicenseManager,
    snackbar,
    tiers,
    designations,
    domains,
    businessFunction,
    departments,
    valueStreamMetrics,
    analytics,
    Marketing
  },
});
